import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { MunicipalitySelect } from "@dhn/components/molecules/municipality-select";
import { ProvinceSelect } from "@dhn/components/molecules/province-select";
import { SectorSelect } from "@dhn/components/molecules/sector-select";
import ReactNumber from "react-number-format";
import LogoUploader from "@dhn/components/molecules/logo-uploader";
import useLogoPreview from "../../hooks/useLogoPreview";
import ReactSelect from "react-select";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";
import ReactFormat from "react-number-format";

export default function GeneralTab({
  state,
  onChange,
  addFile,
  dataState,
  params,
  optionsPrintTypes,
}) {
  const logoPreview = useLogoPreview(state?.fileLogo, state?.id);


  if (!Object.keys(state || {})?.length && !!params)
    return <div className="d-flex justify-content-center m-5">Loading</div>;


  return (
    <div className="animated fadeIn">
      <Row form className="d-flex align-items-end">
        <Col md={3}>
          <Label>Nombre:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("name", value, "pharmacyProvider")
            }
            value={state?.name || ""}
            placeholder="Digitar Consultorio"
          />
        </Col>
        <Col md={2.5}>
          <Label>Persona Juridica:</Label>
          <SelectableOptionGroup columns={2}>
            <SelectableOption
              key="legal-personality-physical"
              compact
              icon="fa-user"
              title="Física"
              inputType="radio"
              inputName="legalPersonalityId"
              checked={state?.legalPersonalityId === 1}
              onChange={({ target }) =>
                onChange(target.name, 1, "pharmacyProvider")
              }
            />
            <SelectableOption
              key="legal-personality-moral"
              compact
              icon="fa-building"
              title="Moral"
              inputType="radio"
              inputName="legalPersonalityId"
              checked={state?.legalPersonalityId === 2}
              onChange={({ target }) =>
                onChange(target.name, 2, "pharmacyProvider")
              }
            />
          </SelectableOptionGroup>
        </Col>
        <Col md={2}>
          <Label>NIF:</Label>
          <ReactNumber
            format={
              state?.legalPersonalityId === 1 ? "###-#######-#" : "#-##-#####-#"
            }
            customInput={Input}
            placeholder="Digitar NIF"
            name="nif"
            value={state?.nif}
            onChange={({ target: { value } }) =>
              onChange("nif", value?.trim(), "pharmacyProvider")
            }

          />
        </Col>
        <Col md={2}>
          <Label>Canal:</Label>
          <ReactSelect
            placeholder="Seleccionar Canal"
            className="w-100"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            options={dataState.dataOptionChannel || []}
            value={
              dataState?.dataOptionChannel?.find(
                (item) => item?.id === state?.channelId,
              ) || null
            }
            onChange={(v) => {
              onChange("channelId", v.id, "pharmacyProvider");
            }}
          />
        </Col>
        <Col md={2}>
          <Label>Nombre Comercial:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("commercialName", value, "pharmacyProvider")
            }
            value={state?.commercialName || ""}
            placeholder="Escribir Nombre"
          />
        </Col>
      </Row>
      <Row form className="my-4">
        <Col md={4}>
          <Label>Contacto:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("contactName", value, "pharmacyProvider")
            }
            value={state?.contactName || ""}
            placeholder="Digitar Contacto"
          />
        </Col>
        <Col md={3}>
          <Label>Teléfono:</Label>
          <ReactFormat
            placeholder="Digitar Teléfono"
            className="bg-white"
            customInput={Input}
            format="(###) ###-####"
            displayType="input"
            onChange={({ target: { value } }) =>
              onChange("phone", value?.trim(), "pharmacyProvider")
            }
            value={state?.phone || ""}
          />
        </Col>
        <Col md={3}>
          <Label>Correo Electrónico:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("contactEmail", value?.trim(), "pharmacyProvider")
            }
            value={state?.contactEmail || ""}
            placeholder="Escribir Electrónico"
          />
        </Col>
        <Col md={2}>
          <Label> Tipo de Impresión</Label>
          <ReactSelect
            options={optionsPrintTypes || []}
            getOptionValue={(item) => item}
            getOptionLabel={(item) => item.name}
            value={optionsPrintTypes?.find(
              (a) => a.id === parseInt(state?.printTypeId),
            )}
            placeholder="Seleccione tipo de impresión"
            onChange={(item) => {
              onChange("selectedPrintType", item);
              onChange("printTypeId", item.id, "pharmacyProvider");
            }}
          />
        </Col>
      </Row>
      <Row form className="mt-4 d-flex align-items-end">
        <Col md={8}>
          <Label>Dirección:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("address", value, "pharmacyProvider")
            }
            value={state?.address || ""}
            placeholder="Digitar Dirección"
          />
        </Col>
      </Row>
      <Row form className="mt-4">
        <Col md={12}>
          <LogoUploader
            inputId="center-logo-input"
            title="Logo del consultorio"
            label={logoPreview.label}
            source={logoPreview.source}
            accept="image/png,image/jpeg,image/svg+xml"
            onFileChange={({ target }) => {
              const file = target.files?.[0];
              target.value = "";
              if (file) addFile([file]);
            }}
          />
        </Col>
      </Row>
      <Row form className="mt-4">
        <Col sm="4">
          <ProvinceSelect
            item={{ id: state?.provinceId }}
            onSelect={(item) =>
              onChange("provinceId", parseInt(item.id), "pharmacyProvider")
            }
          />
        </Col>
        <Col sm="4">
          <MunicipalitySelect
            item={{ id: state?.municipalityId }}
            provinceId={state?.provinceId}
            onSelect={(item) =>
              onChange("municipalityId", parseInt(item.id), "pharmacyProvider")
            }
          />
        </Col>
        <Col sm="4">
          <SectorSelect
            item={{ id: state?.sectorId }}
            municipalityId={state?.municipalityId}
            onSelect={(item) =>
              onChange("sectorId", parseInt(item.id), "pharmacyProvider")
            }
          />
        </Col>
      </Row>
    </div>
  );
}
